var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1409 3.99994V8.50731H1.85938V3.99994H22.1409ZM2.31006 10.31H21.6902C21.6902 15.6617 17.3515 20 11.9999 20C6.64817 20 2.31006 15.6617 2.31006 10.31ZM9.69023 17.1203C9.69023 18.4836 10.7955 19.5889 12.1586 19.5889C13.5221 19.5889 14.6272 18.4836 14.6272 17.1203V13.5675C14.6272 12.2039 13.5221 11.0986 12.1586 11.0986C10.7955 11.0986 9.69023 12.2039 9.69023 13.5675V17.1203ZM12.1012 18.0463C13.138 18.0463 13.9785 17.2055 13.9785 16.1688C13.9785 15.1319 13.138 14.2914 12.1012 14.2914C11.0643 14.2914 10.224 15.1318 10.224 16.1688C10.224 17.2055 11.0643 18.0463 12.1012 18.0463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.294aa1988106afe8885e72d113734d5d.svg";
export { ForwardRef as ReactComponent };